import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "lib/apiInstance";
import { LOCAL_STORAGE } from "utils/constant";
import { BASE_URL, EndpointsSlug } from "./endpoints";

export const publicService = createApi({
  reducerPath: "publicService",
  baseQuery: baseQueryWithReauth({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem(LOCAL_STORAGE.USER_TOKEN) || "";
      headers.set("Content-type", "application/json; charset=UTF-8");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["pending_level", "public_level"],
  endpoints: (builder) => ({
    getAllPublicLevels: builder.query({
      query: (params) => ({
        url: EndpointsSlug.GET_PUBLIC_LEVELS,
        method: "GET",
        params,
      }),
      providesTags: ["public_level"],
    }),
    getPendingPublicLevels: builder.query({
      query: (params) => ({
        url: EndpointsSlug.GET_PENDING_PUBLIC_LEVELS,
        method: "GET",
        params,
      }),
      providesTags: ["pending_level"],
    }),
    getRejectedPublicLevels: builder.query({
      query: (params) => ({
        url: EndpointsSlug.GET_REJECTED_PUBLIC_LEVELS,
        method: "GET",
        params,
      }),
      providesTags: ["rejected_level"],
    }),
    approvePendingLevel: builder.mutation({
      query: (levelId) => ({
        url: `${EndpointsSlug.APPROVE_PUBLIC_LEVEL}/${levelId}`,
        method: "POST",
      }),
      invalidatesTags: ["pending_level", "public_level", "rejected_level"],
    }),
    rejectPendingLevel: builder.mutation({
      query: ({ levelId, reason }) => ({
        url: `${EndpointsSlug.REJECT_PUBLIC_LEVEL}/${levelId}`,
        method: "POST",
        body: { reason },
      }),
      invalidatesTags: ["pending_level", "rejected_level"],
    }),
  }),
});

export const {
  useGetAllPublicLevelsQuery,
  useGetPendingPublicLevelsQuery,
  useGetRejectedPublicLevelsQuery,
  useApprovePendingLevelMutation,
  useRejectPendingLevelMutation,
} = publicService;

export default publicService;
